import { ArrowDown } from 'lucide-react';
import { CONTACT_HERO } from '@/data/contact';
import { Reveal } from '../Reveal';
import { scrollToId } from '@/lib/scroll';
import { trackEvent } from '@/lib/analytics';

export const ContactHero = () => (
  <section aria-labelledby="contact-hero-heading" data-testid="contact-hero" className="bg-white py-16 sm:py-24">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
      <Reveal>
        <p className="flex items-center gap-3">
          <span className="font-mono text-xs font-medium tracking-widest text-gold-700">01</span>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold-700">
            {CONTACT_HERO.eyebrow}
          </span>
        </p>
        <h1
          id="contact-hero-heading"
          data-testid="contact-hero-heading"
          className="mt-4 text-balance text-4xl font-extrabold tracking-tight text-navy-900 sm:text-5xl"
        >
          {CONTACT_HERO.heading}
        </h1>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg">
          {CONTACT_HERO.copy}
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            onClick={() => {
              trackEvent('contact_hero_booking_click');
              scrollToId('#book-appointment');
            }}
            data-testid="contact-hero-book-btn"
            className="group inline-flex items-center justify-center gap-2 rounded-md bg-navy-900 px-6 py-3.5 text-sm font-bold text-white transition-colors hover:bg-navy-700"
          >
            Book an Appointment
            <ArrowDown className="h-4 w-4 transition-transform duration-200 group-hover:translate-y-0.5" aria-hidden="true" />
          </button>
          <button
            type="button"
            onClick={() => {
              trackEvent('contact_hero_enquiry_click');
              scrollToId('#contact-enquiry');
            }}
            data-testid="contact-hero-enquiry-btn"
            className="group inline-flex items-center justify-center gap-2 rounded-md border-2 border-navy-900 px-6 py-3 text-sm font-bold text-navy-900 transition-colors hover:bg-navy-900 hover:text-white"
          >
            Send an Enquiry
            <ArrowDown className="h-4 w-4 transition-transform duration-200 group-hover:translate-y-0.5" aria-hidden="true" />
          </button>
        </div>
      </Reveal>

      <Reveal delay={0.12}>
        <img
          src={CONTACT_HERO.image?.src}
          alt={CONTACT_HERO.image.alt}
          width={CONTACT_HERO.image.width}
          height={CONTACT_HERO.image.height}
          data-testid="contact-hero-image"
          className="aspect-[4/3] w-full rounded-2xl object-cover shadow-lift"
        />
      </Reveal>
    </div>
  </section>
);
